import { Inject, Injectable, LOCALE_ID } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { ApiService } from "../pages/common/api.service";
import { ILanguage } from "../shared/components/header/header.component";

@Injectable({
  providedIn: "root",
})
export class LanguageGuard implements CanActivate {
  constructor(
    public _apiService: ApiService,
    @Inject(LOCALE_ID) public locale: string
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (
      !sessionStorage.getItem("userLanguage") ||
      (sessionStorage.getItem("userLanguage") &&
        JSON.parse(sessionStorage.getItem("userLanguage"))?.attributes
          ?.iso639_1 !== this.locale)
    ) {
      return this._apiService
        .getAllLanguages()
        .toPromise()
        .then((res: { data: ILanguage[] }) => {
          let selectedLanguage = res?.data.find(
            (language: ILanguage) =>
              language?.attributes?.iso639_1 === this.locale
          );
          if (selectedLanguage) {
            sessionStorage.setItem(
              "userLanguage",
              JSON.stringify(selectedLanguage)
            );
            return true;
          }
        })
        .catch((err) => {
          console.log("error while fetching languages", err);
          return true;
        });
    } else {
      return true;
    }
  }
}
